<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { Link } from "@inertiajs/vue3";

defineProps(["mission_vision"]);
</script>
<template>
    <div
        class="flex flex-wrap content-start shadow shadow-gray-400 rounded-md sm:p-4 p-2 border-l-4 border-[#1CBED1] pt-4 mt-4"
    >
        <div class="w-full">
            <h2
                class="title-font font-medium xl:text-2xl text-xl mb-2 text-black"
            >
                {{ $t("Our Commitment") }}
            </h2>
            <p
                class="leading-relaxed sm:text-[15px] text-base mt-2 text-gray-500 sm:mb-4 mb-2"
                v-html="
                    locale === 'BN'
                        ? mission_vision?.bn_mission
                        : mission_vision?.mission
                "
            ></p>
        </div>
    </div>
    <!-- <div
        class="flex flex-wrap content-start border-1 shadow shadow-gray-400 rounded-md sm:mt-6 mt-4 p-4 border-l-4 border-[#1CBED1]"
    >
        <div class="w-full">
            <h2
                class="title-font font-medium xl:text-2xl text-xl mb-2 text-black"
            >
                {{ $t("mission-vision.vision") }}
            </h2>

            <p
                class="leading-relaxed text-[15px] text-base mt-2 text-gray-500 sm:mb-4 mb-2"
                v-html="
                    locale === 'BN'
                        ? mission_vision?.bn_vision
                        : mission_vision?.vision
                "
            ></p>
        </div>
    </div> -->

    <Link
        :href="route('booking.page')"
        class="mt-6 border border-transparent bg-[#1CBED1] hover:bg-[#1565C0] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1565C0] w-4/5 rounded-md shadow-lg transition duration-300 flex justify-center items-center py-2 px-3 tracking-wider font-semibold text-black xl:text-[17px] text-base text-center"
        aria-current="page"
    >
        {{ $t("mission-vision.button") }}
    </Link>
</template>
<style scoped></style>
